import withContext from 'hoc/withContext';
import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';

import { Progress, ProgressBarWrapper, ProgressPlaceholder, ProgressStatus } from './ProgressBar.styles';

const getProgressText = (progress = 0) => {
  if (progress >= 25 && progress < 50) {
    return 'progressBar.text2';
  }

  if (progress >= 50 && progress < 75) {
    return 'progressBar.text3';
  }

  if (progress >= 75 && progress < 85) {
    return 'progressBar.text4';
  }

  if (progress >= 85 && progress < 100) {
    return 'progressBar.text5';
  }

  if (progress === 100) {
    return 'progressBar.text6';
  }

  return 'progressBar.basicStep';
};

class ProgressBar extends PureComponent<Partial<IContext> & Partial<ITextContext>> {
  render() {
    const { showStatus, paymentProgressText, progress } = this.props;

    if (showStatus) {
      return (
        <ProgressBarWrapper className="progress-bar__container">
          <ProgressStatus>{paymentProgressText || <FormattedMessage id={getProgressText(progress)} />}</ProgressStatus>
          <Progress progress={progress} className="progressbar" />
          <ProgressPlaceholder />
        </ProgressBarWrapper>
      );
    }

    return false;
  }
}

export default withContext(ProgressBar);
